<template>
  <div class="loader_container">
    <v-progress-circular indeterminate color="#52B61B"></v-progress-circular>
  </div>
</template>

<script>
export default {
    
};
</script>

<style scoped>
.loader_container {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  z-index: 10;
}
</style>